import { CompareChangeType } from "../types";

/**
 * Pill (Label) colors per change type.
 *
 * These are passed to the library `Label` via `customColor`/`textColor`, which
 * expect concrete color values (the component ignores CSS custom properties for
 * `textColor` in this build — see the `CustomTextColor` Storybook story). The
 * hex values match the design tokens (`--color-red/yellow/green-*`).
 */
export const CHANGE_STATUS_COLORS: Record<
  CompareChangeType,
  { background: string; text: string } | null
> = {
  added: { background: "#bef4ce", text: "#1b6031" }, // green-200 / green-800
  edited: { background: "#ffeda4", text: "#534200" }, // yellow-200 / yellow-900
  removed: { background: "#ffdede", text: "#8c1010" }, // red-100 / red-900
  reordered: { background: "#ffeda4", text: "#534200" }, // yellow-200 / yellow-900
  unchanged: null,
};

/** Row background tint and left accent bar per change type. */
export const CHANGE_ROW_TINT: Record<
  CompareChangeType,
  { background: string; bar: string } | null
> = {
  added: {
    background: "var(--color-green-50, #f1fcf3)",
    bar: "var(--color-green-500, #2ab556)",
  },
  edited: {
    background: "var(--color-yellow-50, #fffbe8)",
    bar: "var(--color-yellow-500, #fecf00)",
  },
  removed: {
    background: "var(--color-red-50, #fff0f0)",
    bar: "var(--color-red-500, #ff2d2d)",
  },
  reordered: {
    background: "var(--color-yellow-50, #fffbe8)",
    bar: "var(--color-yellow-500, #fecf00)",
  },
  unchanged: null,
};

export const hasStatusLabel = (changeType?: CompareChangeType): boolean =>
  !!changeType && changeType !== "unchanged";
